module.exports = "/_next/static/images/top-9b454d95b8654abc593b69b5891fb0a8.jpg";